















import { Component, Prop, Vue } from "vue-property-decorator";
import { Service } from "@/api/types";
import ShopMenuItemServiceSinglePackage from "./ShopMenuItemServiceSinglePackage.vue";
import ShopMenuItemServiceMultiPackage from "./ShopMenuItemServiceMultiPackage.vue";

@Component({
  components: {
    ShopMenuItemServiceSinglePackage,
    ShopMenuItemServiceMultiPackage
  }
})
export default class ShopMenuItemService extends Vue {
  @Prop() private service!: Service;
  @Prop({ default: "€" }) private currency!: string;
  @Prop({ default: false }) private selected!: boolean;

  get hasSinglePackage(): boolean {
    return this.service.packagesDisplayOrder.length === 1;
  }
}
